import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

const Terms = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: { xs: 2.5, md: 4 } }}>
        <Typography variant="h3" fontWeight={900} sx={{ mb: 2 }}>
          Conditions générales d'utilisation
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Dernière mise à jour : 18/02/2026
        </Typography>

        <Box sx={{ display: 'grid', gap: 2.25 }}>
          <Typography variant="body1">
            Ces conditions générales décrivent les règles d’utilisation du logiciel Facteio (SG DIGITAL).
            Elles servent de base et peuvent être adaptées selon votre contexte (notamment si vous ajoutez des moyens de paiement,
            une politique de confidentialité dédiée, ou des clauses spécifiques).
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            1. Objet
          </Typography>
          <Typography variant="body1">
            Facteio est un logiciel de gestion de devis et factures, destiné à simplifier la création de documents, le suivi,
            et certaines opérations de préparation comptable.
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            2. Compte utilisateur
          </Typography>
          <Typography variant="body1">
            L’utilisateur est responsable de la confidentialité de ses identifiants et de l’usage fait de son compte.
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            3. Offres et abonnement
          </Typography>
          <Typography variant="body1">
            Le service propose une offre gratuite (FREE) et une offre payante (PRO) donnant accès à des fonctionnalités avancées.
            Les caractéristiques exactes et tarifs peuvent évoluer ; les informations à jour sont affichées dans l’interface.
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            4. Données et sauvegardes
          </Typography>
          <Typography variant="body1">
            Vous restez propriétaire de vos données. Nous mettons en œuvre des mesures raisonnables de protection,
            mais aucun système n’est infaillible.
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            5. Responsabilités
          </Typography>
          <Typography variant="body1">
            Facteio fournit des outils d’édition et de suivi, mais ne remplace pas un conseil juridique/comptable.
            Vous êtes responsable de l’exactitude des informations saisies et des documents transmis à vos clients.
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            6. Support
          </Typography>
          <Typography variant="body1">
            Pour toute question, vous pouvez nous contacter via le formulaire de contact ou à l’adresse :
            sgdigitalweb13@gmail.com.
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            7. Modifications
          </Typography>
          <Typography variant="body1">
            Ces conditions peuvent être mises à jour. La date de mise à jour est indiquée en haut de page.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default Terms;
